import Api from "../api/api";

export default async (props) => {
  const { data } = await Api.post(`loan-post/${props.id}`, props.body);
  return data;
};
